import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Select from '@starbucks-web/pattern-library/lib/components/select';
import shouldDisplayError from '@starbucks-web/pattern-library/lib/components/form-container/should-display-error';

import { limitSignificantDigitsSelector } from 'shared/app/shell/state/selectors/config';

import CustomAmountField from './custom-amount-field';
import { giftAmountOptionsSelector } from 'gift/app/state/selectors';

import messages from './messages';

const GiftAmount = ({
  amount,
  customAmount,
  customOptionValue,
  setCustomOptionValue,
}) => {
  const { formatMessage, formatNumber } = useIntl();
  const limitSigDigits = useSelector(limitSignificantDigitsSelector);
  const giftAmountOptions = useSelector(giftAmountOptionsSelector);

  return (
    <React.Fragment>
      <Select
        {...amount.input}
        error={shouldDisplayError(amount)}
        errorMessage={formatMessage(messages.amountSelectError)}
        label={formatMessage(messages.amountLabel)}
        value={amount?.input?.value?.toString()}
      >
        {giftAmountOptions.map((option) => {
          const optionString = option.toString();

          return (
            <option key={optionString} value={optionString}>
              {formatNumber(option, limitSigDigits)}
            </option>
          );
        })}

        <option value={customOptionValue}>
          {formatMessage(messages.customAmountOption)}
        </option>
      </Select>
      <CustomAmountField
        customAmount={customAmount}
        customOptionValue={customOptionValue}
        isActive={Boolean(customAmount)}
        limitSigDigits={limitSigDigits}
        setCustomOptionValue={setCustomOptionValue}
      />
    </React.Fragment>
  );
};

export default GiftAmount;
